import { render, staticRenderFns } from "./DataTreeTable.vue?vue&type=template&id=f4503bec&scoped=true&"
import script from "./DataTreeTable.vue?vue&type=script&lang=js&"
export * from "./DataTreeTable.vue?vue&type=script&lang=js&"
import style0 from "./DataTreeTable.vue?vue&type=style&index=0&id=f4503bec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4503bec",
  null
  
)

export default component.exports